export const clearCNPJ = (cnpj) => {
  return cnpj.replace(/[^\d]+/g, ''); 
}
  
export const clearCEP = (cep) => {
  return cep.replace(/[^\d]+/g, ''); 
} 